<app-header></app-header>
<section class="container clearfix pt-5 pb-5">
  <div class="row">
    <div class="col-12 col-md-12 col-lg-12 col-xl-12 offset-0 offset-md-0 offset-lg-0 offset-xl-0 mt-4 pb-3 text-md-left">
			<h1 data-animate-effect="fadeIn">Parquímetros</h1>
      <h2 class="mt-3">En esta página podrás conocer la información sobre el sistema de parquímetros de la Ciudad de México.</h2>
      <!-- img src="assets/images/main-image.png" width="100%" alt="" class="rounded-corners mt-4" -->
    </div>
  </div>
  <div class="row mt-5 pt-4">
    <div class="col-12 col-md-6">
    <h2 class="h_parq">Ingresos</h2>
    <p class="p_home">
      En esta sección podrás conocer los ingresos que se generan en cada Zona de parquímetros y el monto que se paga al Gobierno de la Ciudad de México, conforme a las normas vigentes. Puedes explorar y descargar estos datos dando click <a href="https://datos.cdmx.gob.mx/explore/dataset/ingresos-parquimetros-2018" style="color:#68b418;" target="blank"> aquí.</a> El siguiente mapa muestra información histórica sobre los ingresos por el pago de parquímetros en la Ciudad de México. Puedes activar uno o más filtros, que se encuentran del lado izquierdo, para ver la información de alcaldía, año, mes y zona de parquímetros que más te interese. <strong>La información del mapa se actualizará con tu elección de filtros. </strong>
    </p>
    </div>
    <div class="col-12 col-md-6" *ngIf="ingresos.filters">
      <app-map-park [data]="ingresos"></app-map-park>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12 col-md-6">
      <a name="zonas"></a>
      <h2 class="h_parq  mt-5">Zonas de operación  y equipos de cobro</h2>
      <p class="p_home">
        En el mapa se identifica cada una de las Zonas de parquímetros que actualmente están en operación. También se pueden ver las empresas a las que se otorgó la concesión y la ubicación de los equipos de cobro. <br /> <br /> Cabe aclarar que, por el momento, se presentan sólo las zonas de parquímetros que corresponden al sistema conocido como ecoParq. <br /> <br /> Puedes explorar y descargar estos datos dando click <a href="https://datos.cdmx.gob.mx/dataset/equipos-de-cobro1" style="color:#68b418;" target="blank"> aquí.</a>
      </p>
    </div>
    <div class="col-12 col-md-6" *ngIf="equipos.filters">
      <app-map-park-points [data]="equipos"></app-map-park-points>
    </div>
  </div>

  <!-- ods-dataset-context context="poligonoscomites, equiposdecobro1, poligonosconcesionarios " poligonoscomites-dataset="poligonos-comites" equiposdecobro1-dataset="equipos-de-cobro1" poligonosconcesionarios-dataset="poligonos-concesionarios">
    <div class="col-lg-3 col-sm-12">
      <ods-facets context="poligonoscomites" >
          <br />
          <h3>Zona de Parquímetros</h3> <ods-facet name="colonia"></ods-facet>
          <h3 >Empresa Concesionaria</h3> <ods-facet name="concesionaria"></ods-facet>
      </ods-facets>
    </div>
    <div class="col-lg-9 col-sm-12">
      <ods-map no-refit="true" scroll-wheel-zoom="false" display-control="true" search-box="true" toolbar-fullscreen="true" toolbar-geolocation="true" location="13,19.39468,-99.18643">
           <ods-map-layer-group>
              <ods-map-layer context="poligonoscomites" color-categories="{'Anzures':'#6D7A87','Bénito Juárez Norte':'#619FC8','Bénito Juárez Sur':'#F7C87E','Florida':'#CB516D','Lomas-Virreyes':'#F7AD84','Polanco':'#5D9FA3','Roma-Hipódromo':'#64905C'}" color-by-field="colonia" color-categories-other="#C32D1C" picto="ods-circle" show-marker="true" display="categories" shape-opacity="0.8" point-opacity="1" border-color="#FFFFFF" border-opacity="1" border-size="1" border-pattern="solid" caption="true" title="Colonias Parquímetros" size="4"></ods-map-layer>
          </ods-map-layer-group>
          <ods-map-layer-group>
              <ods-map-layer context="equiposdecobro1" color="#C32D1C" picto="ods-parking" show-marker="false" display="auto" function="COUNT" expression="tessellate" shape-opacity="0.5" point-opacity="1" border-color="#FFFFFF" border-opacity="1" border-size="1" border-pattern="solid" caption="true" title="Equipos de cobro" size="4" size-min="3" size-max="5" size-function="linear"></ods-map-layer>
          </ods-map-layer-group>
           <ods-map-layer-group>
      <ods-map-layer context="poligonosconcesionarios" color="#eb6657" picto="ods-circle" show-marker="true" display="auto" shape-opacity="0.5" point-opacity="1" border-color="#FFFFFF" border-opacity="1" border-size="1" border-pattern="solid" caption="true" title="Polígonos Sin Operar" size="4" size-min="3" size-max="5" size-function="linear"></ods-map-layer>
      </ods-map-layer-group>
      </ods-map>
    </div>
  </ods-dataset-context -->

  <div class="row mt-5">
    <div class="col-md-12 col-12 mt-4">
      <h2 class="h_parq" id="info">Información general sobre parquimetros</h2>
      <!-- h3>Ingresos desde 2012</h3 -->
      <div>
        <iframe width="100%" height="600" src="https://datos.cdmx.gob.mx/dataset/ingresos-parquimetros/resource/1eab9b86-e2dd-4f7f-95f6-615447bd4987/view/3ff3c495-6768-4b23-9c1e-7c9547110cbb" frameBorder="0"></iframe>
           <!-- ods-dataset-context context="pruebaparquimetros" pruebaparquimetros-dataset="prueba-parquimetros">
            <ods-table context="pruebaparquimetros"></ods-table>
            </ods-dataset-context -->
      </div>
      <p class="mt-5" style="margin-top: 2rem;">*La información histórica de los ingresos recaudados por los equipos de parquímetros serán subidos a este portal de manera paulatina.</p>
      <a href="https://datos.cdmx.gob.mx/dataset/ingresos-parquimetros/resource/1eab9b86-e2dd-4f7f-95f6-615447bd4987" target="_blank" style="text-transform: capitalize;">Explora o descarga los Datos</a>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-md-6 col-12">
      <h2>Concesiones Activas</h2>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Concesión</th>
            <th scope="col">Operador</th>
            <th scope="col">Cajones</th>
            <th scope="col">Parquímetros</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>Polanco-Anzures</td>
            <td>Operadora de Estacionamientos Bicentenario (OEB)</td>
            <td>7,415</td>
            <td>507</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Lomas – Chapultepec</td>
            <td>Operadora de Estacionamientos Bicentenario (OEB)</td>
            <td>5,095</td>
            <td>185</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>Roma – Hipódromo</td>
            <td>Operadora de Estacionamientos Bicentenario (OEB)</td>
            <td>5,869</td>
            <td>348</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>Bénito Juárez Norte</td>
            <td>COPEMSA Metropolitana</td>
            <td>3,255</td>
            <td>225</td>
          </tr>
          <tr>
            <th scope="row">5</th>
            <td>Bénito Juárez Sur</td>
            <td>Mojo Real Estate</td>
            <td>3,183</td>
            <td>205</td>
          </tr>
          <tr>
            <th scope="row">6</th>
            <td>Insurgentes – Florida</td>
            <td>Nueva Generación de Estacionamientos</td>
            <td>948</td>
            <td>83</td>
          </tr>
        </tbody>
      </table>
      <p class="mt-5" style="margin-top: 2rem;">*El número de cajones y parquímetros puede variar dependiendo de varios factores en cada zona de parquímetros.</p>
    </div>
    <div class="col-md-6 col-12">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4>Permisos para residentes</h4>
        </div>
        <div class="card-body p-4">
          <p class="p_home">Las y los residentes de las colonias donde hay parquímetros pueden obtener una autorización para ocupar un lugar sin pagar, si cumplen con los requisitos que establece el "Reglamento para el control de estacionamiento en la vía pública de la Ciudad de México".<br /><br />Mas información en: <a style="color:#68b418;" href="https://www.ecoparq.cdmx.gob.mx/tramites-y-servicoos_01" target="blank"> ecoparq.cdmx.gob.mx/tramites-y-servicoos_01 </a></p>
        </div>
      </div>

      <div class="card rounded-corners border mt-4">
        <div class="card-header bg-light">
          <h4>Antecedentes y otros documentos</h4>
        </div>
        <div class="card-body p-4">
          <p class="p_home">Aquí podrás consultar información histórica sobre el sistema de parquímetros de la Ciudad de México.<br /><br />Mas información en: <a style="color:#68b418;" href="https://www.ecoparq.cdmx.gob.mx/atribuciones" target="blank">  ecoparq.cdmx.gob.mx/atribuciones </a></p>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12" id="headings">
      <h2 class="h_parq">Preguntas Frecuentes</h2>
    </div>
    <div class="col-md-12 col-12 mb-4 mt-5">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Cuál es la tarifa vigente?</h4>
        </div>
        <div class="card-body p-4">
          <p>La tarifa autorizada para parquímetros es de $2.56 pesos por cada 15 minutos, de acuerdo al Código Fiscal de la Ciudad de México, y el pago mínimo es de $2.00 pesos.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿En qué horario operan los parquímetros?</h4>
        </div>
        <div class="card-body p-4">
          <p>De lunes a viernes, de 8 a 20 hrs. en la delegación Benito Juárez y en la colonias Anzures, Lomas de Chapultepec y en la colonia Florida.<br /> La zona del horario ampliado en Polanco está delimitada por las avenidas Arquímedes, Horacio, Moliere y Reforma, y opera de miércoles a sábado de 8:00 a 01:00 horas del día siguiente. <br /> En Roma y Condesa, de lunes a miércoles de 8:00 a 20:00 horas y con horario ampliado de jueves a sábado de 8:00 a 1:00 horas del día siguiente.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Cuáles son los medios de pago?</h4>
        </div>
        <div class="card-body p-4">
           <ol>
             <li> Efectivo pagando directamente en el parquímetro. </li>
             <li> Tarjeta de Prepago. </li>
             <li> Pago vía celular por medio las aplicaciones:
              <ul>
                 <li> Blinkay: para las colonias Noche Buena, Extremadura Insurgentes, Insurgentes Mixcoac, San José Insurgentes y Crédito Constructor. </li>
                 <li> Parkum: para las colonias Anzures, Ampliación Nápoles, Condesa, Crédito Constructor, Ciudad de los Deportes, Extremadura Insurgentes, Florida, Hipódromo, Insurgentes Mixcoac, Lomas, Nápoles, Nochebuena, Polanco, Roma Norte y San José Insurgentes.</li>
                 <li> Mueve Ciudad: para las colonias de Polanco, Anzures, Lomas y Roma-Condesa. </li>
              </ul>
             </li>
          </ol>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Qué hacer si inmovilizan mi auto?</h4>
        </div>
        <div class="card-body p-4">
          <ol>
            <li> En tu parabrisas encontrarás la infracción con línea de captura.</li>
            <li> Deberás de realizar el pago correspondiente ($258.90 de acuerdo al artículo 230, fracción III, del Código Fiscal de la Ciudad de México), en los establecimientos autorizados más cercanos al lugar en donde te encuentres.</li>
            <li> Después, debes llamar al teléfono que se encuentra en el inmovilizador para que te lo retiren.</li>
          </ol>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Las motocicletas pagan parquímetro?</h4>
        </div>
        <div class="card-body p-4">
          <p>Las motocicletas están exentas de pago, pero pueden ser infraccionadas si no se estacionan en el lugar destinado para ello, que es la zona con un balizamiento color azul.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Podré realizar mi trámite si cuento con placas de otra entidad?</h4>
        </div>
        <div class="card-body p-4">
          <p>Conforme al Art. 22 del Reglamento para el Control de Estacionamiento en Vía Pública de la Ciudad de México, publicado el 02 de agosto de 2017, la presentación de la Tarjeta de Circulación, emitida por la Secretaría de Movilidad de la CDMX, es uno de los requisitos obligatorios para la realización del trámite.</p>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">Si cambio placas y tengo Permiso vigente (con las placas antiguas), ¿Éste es válido?</h4>
        </div>
        <div class="card-body p-4">
          <p>En este caso, se deberá iniciar un nuevo trámite para obtener el permiso con las placas nuevas, cumpliendo la totalidad de los requisitos establecidos -> <a href="https://www.semovi.cdmx.gob.mx/tramites-y-servicios/bicis-y-parquimetros/parquimetros/permisos-renovables-para-residentes" target="blank" style="color: #009f98">https://www.semovi.cdmx.gob.mx/tramites-y-servicios/bicis-y-parquimetros/parquimetros/permisos-renovables-para-residentes</a> </p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">Si soy residente ¿Puedo estacionarme en cualquier lugar?</h4>
        </div>
        <div class="card-body p-4">
          <p>Si tienes un Permiso de residente, conforme al plano que se anexa al mismo, podrás estacionar tu vehículo en el perímetro cercano al domicilio.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">Si mi vehículo está a nombre de una Persona Moral ¿Puedo obtener el Permiso Renovable para Residentes?</h4>
        </div>
        <div class="card-body p-4">
          <p>En caso de que el vehículo esté a nombre de Persona Moral, el residente deberá acreditar con el Acta Constitutiva y escrito libre del Representante Legal que el vehículo es de uso particular del residente.</p>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Cuál es el tiempo máximo de permanencia?</h4>
        </div>
        <div class="card-body p-4">
          <p>El tiempo máximo de permanencia varía de acuerdo a la zona en la que te estaciones. Lo puedes verificar en el parquímetro más cercano a la calle en la que te encuentres o en la app que estés utilizando.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Cómo puedo solicitar que pongan parquímetros en mi colonia?</h4>
        </div>
        <div class="card-body p-4">
          <p>Deberás de ingresar un escrito libre,  realizando la solicitud, en nuestro módulo central ubicado en Av. Álvaro Obregón 269, PB, Col. Roma Norte, ventanilla 1 de lunes a viernes de 9 a 15 hrs.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Por qué razones me pueden infraccionar?</h4>
        </div>
        <div class="card-body p-4">
          <p>Las razones de infracción están establecidas en el Reglamento de Tránsito vigente:</p>
          <ul style="list-style-type:circle;">
            <li> Que no se haya realizado el pago. </li>
            <li>  Que el comprobante de pago no sea visible desde el exterior del vehículo. </li>
            <li> Que haya concluido el tiempo pagado, exhibido en el comprobante de pago. </li>
            <li>  Que la fecha del comprobante de pago sea distinta a la del día actual.</li>
            <li> Que el número de placas que aparezca impreso en el comprobante de pago no coincida con el número de placas del vehículo estacionado.</li>
            <li>  Que el vehículo se encuentre estacionado invadiendo otro cajón de parquímetros o  fuera de la zona marcada para estacionamiento.</li>
            <li>Que el vehículo estacionado no coincida, por sus dimensiones o naturaleza, con el tipo de vehículo al que está destinado el cajón.</li>
            <li>Que el Permiso Renovable para Residentes haya perdido vigencia, no sea visible desde el exterior o no coincida con el número de placa o que se encuentre fuera del polígono autorizado.</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Qué es el Permiso Renovable para Residentes?</h4>
        </div>
        <div class="card-body p-4">
          <p>
              Es un permiso que exime del pago de parquímetro, que se otorga a los residentes de las zonas ecoParq cuando su inmueble esté destinado a vivienda y no cuente con cochera.
Para obtener tu permiso acude al módulo central, ubicado en Av. Álvaro Obregón 269, PB, Col. Roma Norte, ventanilla 1 de lunes a viernes de 9 a 15 hrs.
Conoce la documentación que debes presentar -> <a href="https://www.ecoparq.cdmx.gob.mx/tramites-y-servicoos_01" target="blank" style="color: #009f98">https://www.ecoparq.cdmx.gob.mx/tramites-y-servicoos_01</a>
El trámite de permiso para residentes es totalmente GRATUITO.
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Cuál es el tiempo de respuesta del trámite?</h4>
        </div>
        <div class="card-body p-4">
          <p>El tiempo de respuesta a la solicitud, es hasta 40 días hábiles, iniciado el trámite, conforme al Art. 89 de la Ley de Procedimientos Administrativos de la CDMX.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Qué sucede si no cumplo con todos mis requisitos?</h4>
        </div>
        <div class="card-body p-4">
          <p>En caso de no cumplir con la totalidad de los requisitos, se le concederá un término de 5 días para exhibirlos.</p>
        </div>
      </div>
    </div>


    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Cuál es la vigencia de mi Permiso de Residentes?</h4>
        </div>
        <div class="card-body p-4">
          <p>Es de un año, se debe tramitar nuevamente antes del término de su vigencia.</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 mb-4">
      <div class="card rounded-corners border">
        <div class="card-header bg-light">
          <h4 class="mt-2">¿Donde puedo consultar información sobre las aplicaciones?</h4>
        </div>
        <div class="card-body p-4">
          <p><a href="https://www.ecoparq.cdmx.gob.mx/preguntas-frecuentes-apps" target="blank" style="color: #009f98">En esta liga</a> puedes consultar la información sobre las aplicaciones para el pago de parquímetros.</p>
        </div>
      </div>
    </div>
  </div>

</section>

<app-footer></app-footer>
